import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { useLocation, useSearchParams } from 'react-router-dom'

import { UNAUTHENTICATED_REDIRECT_URL } from '@lyrahealth-inc/lyraweb-mobile/src/hooks/useShareSessionStorageAcrossTabs'
import { getRoutesEnabledInNativeApp, SESSION_STORAGE_KEY } from '@lyrahealth-inc/shared-app-logic'
import { useFlags } from '@lyrahealth-inc/shared-app-logic/src/features/flags/useFlags'
import { useGetIsMobileWebBrowser } from '@lyrahealth-inc/ui-core-crossplatform'

import { getIsUserLoggedIn } from '../../data/user/userSelectors'

const usePathChanged = () => {
  const { pathname } = useLocation()
  const [searchParams, setSearchParams] = useSearchParams()
  const isLoggedIn = useSelector(getIsUserLoggedIn)
  const { is1LyraEnabledForCareRoutes } = useFlags()
  const isMobileBrowser = useGetIsMobileWebBrowser()
  const prevPathname = useRef('')
  const unauthenticatedRedirectUrl = searchParams.get('unauthenticatedRedirectUrl')

  // Fix scroll issues on mobile chrome. Contain this to the logged out site only, in case anything in app needs to maintain scroll position.
  useEffect(() => {
    if (isMobileBrowser && !isLoggedIn && prevPathname.current !== pathname) {
      scroll(0, 0)
    }
    prevPathname.current = pathname
  }, [isLoggedIn, isMobileBrowser, pathname])

  useEffect(() => {
    if (
      is1LyraEnabledForCareRoutes !== undefined &&
      getRoutesEnabledInNativeApp(is1LyraEnabledForCareRoutes).includes(pathname)
    ) {
      window.sessionStorage.setItem(SESSION_STORAGE_KEY.NATIVE_APP_FROM_LW, 'true')
      window.location.reload()
    }
  }, [pathname, is1LyraEnabledForCareRoutes])

  // Set unauthenticatedRedirectUrl in sessionStorage from query param
  // Used to persist the redirect url when changing subdomains
  useEffect(() => {
    if (unauthenticatedRedirectUrl) {
      window.sessionStorage.setItem(UNAUTHENTICATED_REDIRECT_URL, unauthenticatedRedirectUrl)

      // Remove the unauthenticatedRedirectUrl param from the URL without reloading
      setSearchParams((params) => {
        const newParams = new URLSearchParams(params)
        newParams.delete('unauthenticatedRedirectUrl')
        return newParams
      })
    }
  }, [unauthenticatedRedirectUrl, setSearchParams])
}

export default usePathChanged
